module.exports = __webpack_public_path__ + "static/img/piramide_pasturas.674aeae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/misics/piramide_pasturas.jpg
// module id = HXVv
// module chunks = 0